import React, { Component } from "react";
import { View, Text, TouchableOpacity, Image } from "react-native";
import chatStyles from "../styles/chatStyles";
import styles from "../styles/customDropdownStyle";
import { ChatButtons } from "./ChatButtons";

const imagesArray = {
  cob: require("../../assets/images/cob.png"),
  brick: require("../../assets/images/brick.png"),
  granite: require("../../assets/images/granite.png"),
  sandstone: require("../../assets/images/sandstone.png"),
};

class Widget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isButtonPressed: false,
      values: [],
      widgetValues: {},
      valuesChanged: false,
      showModel: false,
      selectedIndex: -1,
      hoveredIndex: -1,
    };
  }

  componentDidMount() {
    let widgetValues = {};
    this.props.widget.forEach((element) => {
      if (element.editable) {
        widgetValues[element.name] = element.value;
      }
    });
    this.setState({
      widgetValues,
      valuesChanged: false,
    });
  }

  onWidgetSubmit() {
    let emptyFlag = false;
    let updatedvalues = [];
    if (!this.state.valuesChanged) {
      this.setState({
        widgetValues: {},
      });
      return this.props.updateSentMessage("Confirm");
    }
    Object.keys(this.state.widgetValues).forEach((each) => {
      if (!this.state.widgetValues[each]) {
        emptyFlag = true;
        alert(`Invalid value for ${each}`);
      } else {
        updatedvalues.push(`${each}: ${this.state.widgetValues[each]}`);
      }
    });

    if (!emptyFlag) {
      this.setState({
        widgetValues: {},
      });
      this.props.updateSentMessage(updatedvalues.join(", "));
    }
  }

  onChangeDropdown(widgetName, itemValue) {
    this.setState({
      valuesChanged: true,
      widgetValues: {
        ...this.state.widgetValues,
        [widgetName]: itemValue,
      },
      showModel: false,
    });
  }
  ToggleModel = (index) => {
    this.setState({
      selectedIndex: index,
      showModel:
        index == this.state.selectedIndex ? !this.state.showModel : true,
    });
  };
  onMouseLeave = (index) => {
    this.setState({
      hoveredIndex: -1,
    });
  };

  onMouseEnter = (index) => {
    this.setState({
      hoveredIndex: index,
    });
  };
  renderPopUp = (each, indx) => {
    const { hoveredIndex } = this.state;
    return (
      <View style={styles.popUp}>
        {each.options &&
          each.options.map((eachOption, index) => (
            <View
              key={`widgetDropDown${index}`}
              nativeID={`widgetDropDown${index}`}
              style={
                index == hoveredIndex ? styles.HoveredItemView : styles.itemView
              }
            >
              <TouchableOpacity
                onMouseLeave={() => this.onMouseLeave(index)}
                onMouseEnter={() => this.onMouseEnter(index)}
                onPress={() =>
                  this.onChangeDropdown(each.name, eachOption.stringValue)
                }
                style={styles.touchableOpacityDropDownList}
              >
                {eachOption.icon && (
                  <Image
                    source={imagesArray[eachOption.stringValue.toLowerCase()]}
                    style={styles.dropDownImage}
                  />
                )}
                <Text
                  style={
                    index == hoveredIndex
                      ? styles.txtValueHovered
                      : styles.txtValue
                  }
                >
                  {eachOption.stringValue}
                </Text>
              </TouchableOpacity>
            </View>
          ))}
      </View>
    );
  };
  render() {
    const { widget, buttons, botMessage } = this.props;
    const { selectedIndex, showModel } = this.state;
    return (
      <View style={chatStyles.widgetWrapper}>
        <View style={chatStyles.widgetBody}>
          <View style={chatStyles.widgetContainer}>
            <>
              {widget.map(
                (each, index) =>
                  !each.editable && (
                    <View
                      key={`widgetKey${index}`}
                      nativeID={`widgetKey${index}`}
                      style={chatStyles.widgetBox}
                    >
                      <Text style={chatStyles.widgetHeader}>{each.name}</Text>
                      <Text style={chatStyles.widgetValue}>{each.value}</Text>
                    </View>
                  )
              )}
            </>
            <>
              {widget &&
                widget.map(
                  (each, index) =>
                    each.editable && (
                      <View
                        key={`widgetEditableKey${index}`}
                        style={[
                          chatStyles.editableWidgetBox,
                          chatStyles.margnTop10,
                        ]}
                      >
                        <Text style={[chatStyles.widgetLabel]}>
                          {each.name}
                        </Text>
                        <View style={chatStyles.widgetPicker}>
                          <TouchableOpacity
                            style={[
                              styles.selectedBtn,
                              chatStyles.justContentSpaceBetween,
                            ]}
                            onPress={() => this.ToggleModel(index)}
                          >
                            <Text style={styles.selectedValueStyle}>
                              {this.state.widgetValues[each.name] || ""}
                            </Text>
                            <Image
                              source={require(`../../assets/images/arrowdown.png`)}
                              style={styles.dropDownArrow}
                            />
                          </TouchableOpacity>
                        </View>

                        {selectedIndex == index &&
                          showModel &&
                          this.renderPopUp(each, index)}
                      </View>
                    )
                )}
            </>
          </View>
          {this.state.widgetValues &&
            Object.keys(this.state.widgetValues).length > 0 &&
            this.props.keepButtons && (
              <View style={chatStyles.buttonsRow}>
                <View style={chatStyles.chatButtonCover}>
                  <TouchableOpacity
                    style={chatStyles.chatButton}
                    onPress={() => {
                      this.onWidgetSubmit();
                    }}
                  >
                    <Text style={chatStyles.chatButtonText}>
                      {this.state.valuesChanged ? "Submit" : "Confirm"}
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            )}
        </View>
        {buttons && buttons.length > 0 && (
          <ChatButtons
            buttons={buttons}
            updateSentMessage={this.props.updateSentMessage}
          />
        )}
        <Text style={chatStyles.chatTime}>
          {new Date(botMessage.sentAt).toLocaleString([], {
            hour12: false,
            hour: "2-digit",
            minute: "2-digit",
          })}
        </Text>
      </View>
    );
  }
}
export default Widget;
